// extracted by mini-css-extract-plugin
export default {"container":"style_container__YMq76","content":"style_content__bfaEL"};